import { Route, Routes as RoutesList } from 'react-router';

import { AdvancedApiRoutesConfig } from 'domains/advancedApi/routes';
import { AuthPageContainer } from 'domains/auth/screens/AuthPage';
import { BillingPageContainer } from 'domains/account/screens/BillingPage';
import { CardPaymentFailurePageContainer } from 'domains/account/screens/CardPaymentFailure';
import { CardPaymentSuccessPageContainer } from 'domains/account/screens/CardPaymentSuccessPage';
import { ChainPageContainer } from 'domains/chains/screens/ChainPage';
import { ChainsListPageContainer } from 'domains/chains/screens/ChainsListPage';
import { HomePageContainer } from 'domains/home/screens/HomePage';
import { LoadableAdvancedApiContainer } from 'domains/advancedApi/screens/AdvancedApiPage';
import { NewProjectPageContainer } from 'domains/projects/screens/NewProjectPage';
import { NewTeamPageContainer } from 'domains/teams/screens/NewTeamPage/NewTeamPageContainer';
import { NewsPageContainer } from 'domains/home/screens/NewsPage';
import { NotificationsPageContainer } from 'domains/notifications/screens/NotificationsPage';
import { OAuthPageContainer } from 'domains/oauth/screens/OauthPage';
import { PageNotFound } from 'modules/router/components/PageNotFound';
import { PlatformSwaggerPageContainer } from 'domains/platformSwagger/screens/PlatformSwaggerPage';
import { PricingPageContainer } from 'domains/pricing/screens/PricingPage';
import { ProjectsParamsResolver } from 'domains/projects/routes/components/ProjectsParamsResolver';
import { ReferralsPageContainer } from 'domains/referrals/screens/ReferralsPage';
import { StatisticsPageContainer } from 'domains/statistics/screens/StatisticsPage';
import { SwaggerUIPageContainer } from 'domains/swaggerUI/screens/SwaggerUIPage';
import { TeamsPageContainer } from 'domains/teams/screens/TeamsPage';
import { authRoutesConfig } from 'domains/auth/routes';
import { billingRoutesConfig } from 'domains/account/routes';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { featureConfig } from 'modules/common/featureConfig';
import { getDevRoutes } from 'modules/dev';
import { getUserSettingsRoutes } from 'domains/userSettings/Routes';
import { homeRoutesConfig } from 'domains/home/routes';
import { notificationsRoutesConfig } from 'domains/notifications/routes';
import { oAuthRoutesConfig } from 'domains/oauth/routes';
import { platformSwaggerRoutesConfig } from 'domains/platformSwagger/routes';
import { pricingRoutesConfig } from 'domains/pricing/routes';
import { projectsRoutesConfig } from 'domains/projects/routes';
import { referralsRoutesConfig } from 'domains/referrals/routes';
import { statisticsRoutesConfig } from 'domains/statistics/routes';
import { swaggerUIRoutesConfig } from 'domains/swaggerUI/routes/constants';
import { teamsRoutesConfig } from 'domains/teams/routes';

export const Routes = () => {
  return (
    <RoutesList>
      {/* To get rid of an error when react snap prerenders /rpc/404.html */}
      <Route path="/404.html" element={<PageNotFound />} />
      {featureConfig.isDevUiEnabled && getDevRoutes()}
      <Route
        path={authRoutesConfig.auth.path}
        element={<AuthPageContainer />}
      />
      <Route
        path={pricingRoutesConfig.pricing.path}
        element={<PricingPageContainer />}
      />
      <Route
        path={notificationsRoutesConfig.notifications.path}
        element={<NotificationsPageContainer />}
      />
      <Route
        path={projectsRoutesConfig.projects.path}
        element={<ProjectsParamsResolver />}
      />
      <Route
        path={projectsRoutesConfig.newProject.path}
        element={<NewProjectPageContainer />}
      />
      <Route
        path={referralsRoutesConfig.referrals.path}
        element={<ReferralsPageContainer />}
      />
      <Route
        element={<StatisticsPageContainer />}
        path={statisticsRoutesConfig.statistics.path}
      />
      <Route
        element={<HomePageContainer />}
        path={homeRoutesConfig.home.path}
      />
      <Route
        element={<NewsPageContainer />}
        path={homeRoutesConfig.news.path}
      />
      <Route
        path={billingRoutesConfig.billing.path}
        element={<BillingPageContainer />}
      />
      <Route
        path={billingRoutesConfig.cardPaymentSuccess.path}
        element={<CardPaymentSuccessPageContainer />}
      />
      <Route
        path={billingRoutesConfig.cardPaymentFailure.path}
        element={<CardPaymentFailurePageContainer />}
      />
      <Route
        path={platformSwaggerRoutesConfig.platformSwagger.path}
        element={<PlatformSwaggerPageContainer />}
      />
      <Route
        path={swaggerUIRoutesConfig.swaggerUI.path}
        element={<SwaggerUIPageContainer />}
      />
      {getUserSettingsRoutes()}
      <Route
        path={oAuthRoutesConfig.oAuth.path}
        element={<OAuthPageContainer />}
      />
      <Route
        path={chainsRoutesConfig.chains.path}
        element={<ChainsListPageContainer />}
      />
      <Route
        path={teamsRoutesConfig.newTeam.path}
        element={<NewTeamPageContainer />}
      />
      <Route
        path={teamsRoutesConfig.teams.path}
        element={<TeamsPageContainer />}
      />
      <Route
        path={AdvancedApiRoutesConfig.advancedApi.path}
        element={<LoadableAdvancedApiContainer />}
      />
      <Route
        path={chainsRoutesConfig.chainDetails.path}
        element={<ChainPageContainer />}
      />
      <Route path="*" element={<PageNotFound />} />
    </RoutesList>
  );
};
